import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataEmpPosition,
  dataEmpDept,
}) => {
  const [initialFormData, setInitialFormData] = useState({});

  // useEffect(() => {
  //   const compId = localStorage.getItem("company");
  //   if (compId) {
  //     setFormData((prevData) => ({
  //       ...prevData,
  //       comp_id: compId,
  //     }));
  //   }
  // }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        PST_Id: 0,
        PST_Name: "",
        PST_Remark: "",
        PST_Status: "Y",
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        PST_Id: selectedData.PST_Id,
        PST_Name: selectedData.PST_Name,
        PST_Remark: selectedData.PST_Remark,
        PST_Status: selectedData.PST_Status,
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleInsertEmployee = async () => {
    try {
      const { PST_Id, ...dataToInsert } = formData; // กรอง emp_id ออกก่อน
      const fields = Object.keys(dataToInsert).join(", ");
      const values = Object.values(dataToInsert);

      const res = await insertData("Tb_Set_Position", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting employee:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const formatValues = (data) => {
    const { PST_Id, ...rest } = data;
    return rest;
  };

  const handleUpdateEmployee = async () => {
    try {
      const where = { PST_Id: formData.PST_Id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Position", values, where);
      if (res) {
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Position",
            `WHERE PST_Id = ${selectedData.PST_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      })
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    try {
      if (mode === "I") {
        await handleInsertEmployee();
      } else if (mode === "U") {
        await handleUpdateEmployee();
      }
      await callInitialize();
      setFormData({
        PST_Id: 0,
        PST_Name: "",
        PST_Remark: "",
        PST_Status: "Y",
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/position" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-12">
                <label className="">ชื่อตำแหน่ง</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="PST_Name"
                  value={formData.PST_Name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12">
                <label className="">หมายเหตุ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="PST_Remark"
                  value={formData.PST_Remark || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-12 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="PST_Status"
                  value={formData.PST_Status || "Y"} // Set default value to "Y"
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/position")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateEmployee()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
